import React from 'react';
import style from './installed-badge.scss';
import { composer } from '../../../../component-decorators/composer';
import { Text } from '@wix/design-system';
import { StatusCompleteFilledSmall } from '@wix/wix-ui-icons-common';
import { useSolution } from '../contexts/solution';
export const InstalledBadge = composer()
    .withTranslation()
    .compose(({ t }) => {
    const solution = useSolution();
    const { isBundleAppInstalled } = solution;
    const textWeight = 'thin';
    const textSize = 'tiny';
    return (React.createElement("span", { className: isBundleAppInstalled ? style.bundleBadge : style.centeredView },
        React.createElement(StatusCompleteFilledSmall, { className: style.installedIcon }),
        React.createElement("span", null,
            React.createElement(Text, { size: textSize, weight: textWeight, skin: "success", dataHook: "installed-text" }, isBundleAppInstalled
                ? t('solutionBox.solutionBottomActionBar.BundleInstalled')
                : t('solutionBox.solutionBottomActionBar.installedSolution')))));
});
//# sourceMappingURL=InstalledBadge.js.map